export default __webpack_public_path__ + "static/media/business-account-upgrade-ico.3d3643ca.svg";